module.exports = __webpack_public_path__ + "img/tb(12).049f86cd.png";